import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue";
import dayjs from 'dayjs';
import { inject, provide, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import DefaultStyle from './defaultStyle/index.vue';
import ArabicStyle from './arabicStyle/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const defaultStyleVisible = ref(true);
    const ArabicStyleVisible = ref(false);
    const currentUiStyleObj = ref({
      default: {
        class: 'default-ui-class',
        bgColor: '#011f3c',
        styleName: 'default',
        showImg: true
      },
      style1: {
        class: 'style1-ui-class',
        bgColor: '#1e1c1f',
        styleName: 'style1',
        showImg: true
      },
      style2: {
        class: 'style2-ui-class',
        bgColor: '#1e1c1f',
        styleName: 'style2',
        showImg: false
      },
      arabic: {
        class: 'arabic-ui-class',
        bgColor: '#011f3c',
        styleName: 'arabic',
        showImg: true
      }
    });
    const currentUiStyleOptions = ref(null);
    provide('currentUiStyleOptions', currentUiStyleOptions);
    const uiStyle = ref('arabic'); // const uiStyle = ref('default')
    // 获取当前主题背景颜色风格

    const getCurrentUiStyle = () => {
      currentUiStyleOptions.value = currentUiStyleObj.value[uiStyle.value];
    };

    const changeStyle = styleName => {
      uiStyle.value = styleName;
      getCurrentUiStyle();
    };

    const templateGroupRef = ref(null); // 运营方案主题数据列表

    const tabList = inject('tabList');
    const countriesList = inject('countriesList');
    const vodSearchInfo = reactive({
      visible: false
    });
    const iconLists = ref([{
      url: require('@/assets/imgs/home_icon_search.png'),
      onClick: () => {
        vodSearchInfo.visible = true;
      },
      isShow: () => {
        return true;
      }
    }, {
      url: require('./components/images/home_icon_home.png'),
      onClick: () => {
        toHome();
      },
      isShow: () => {
        return templateGroupRef.value && templateGroupRef.value.cacheComponentList.length > 0 ? true : false;
      }
    }, {
      url: require('./components/images/home_icon_back.png'),
      onClick: () => {
        handleBack();
      },
      isShow: () => {
        return templateGroupRef.value && templateGroupRef.value.cacheComponentList.length > 0 ? true : false;
      }
    }, {
      url: require('@/assets/imgs/home_icon_favorite.png'),
      onClick: () => {
        toHistoryOrCollection('collection');
      },
      isShow: () => {
        return true;
      }
    }, {
      url: require('@/assets/imgs/home_icon_history.png'),
      onClick: () => {
        toHistoryOrCollection('history');
      },
      isShow: () => {
        return true;
      }
    }]);
    const otherStyleIconLists = ref([{
      url: require('./components/images/otherStyle/home_icon_search.png'),
      onClick: () => {
        vodSearchInfo.visible = true;
      }
    }, {
      url: require('./components/images/otherStyle/home_icon_favorite.png'),
      onClick: () => {}
    }, {
      url: require('./components/images/otherStyle/home_icon_history.png'),
      onClick: () => {}
    }]);
    const actionForm = reactive({
      dialogConfig: {
        title: '预览',
        destroyOnClose: true,
        isShowFooter: false
      },
      close: () => {
        emit('update:modelValue', false);
      }
    }); // const formatAMPM = () => {
    //     // console.log('getCurrentTimeZone', getCurrentTimeZone());
    //     let date = new Date()
    //     let hours = date.getHours();
    //     return hours >= 12 ? 'PM' : 'AM';
    // }

    const selectOptions = reactive({
      languageOptions: [],
      countryOptions: [],
      programTypeOptions: [{
        label: 'H.264',
        value: 0
      }, {
        label: 'H.265',
        value: 1
      }],
      formData: {
        language: 'en',
        area: 'All',
        programType: 0
      }
    }); // // 获取所有语言
    // const getAllLanguages = async () => {
    //     const res = await useVodLanguages() as any
    //     selectOptions.languageOptions = res
    // }
    // getAllLanguages()

    const timer = reactive({
      timer: null
    });
    const time = ref('');
    const amOrPM = ref('');

    const getTime = () => {
      let date = new Date();
      let hours = date.getHours();
      amOrPM.value = hours >= 12 ? uiStyle.value == 'arabic' ? 'بعد الظهر' : 'PM' : uiStyle.value == 'arabic' ? 'الصباح' : 'AM';
      time.value = dayjs().format('HH:mm');
    };

    const pollTime = () => {
      if (timer.timer) {
        clearInterval(timer.timer);
      }

      timer.timer = setInterval(() => {
        getTime();
      }, 1000);
    };

    const onSearchItemClick = item => {
      console.log(item);
      vodSearchInfo.visible = false;
      templateGroupRef.value.onCardClick({ ...item
      });
    };

    const handleBack = () => {
      templateGroupRef.value.returnBackComponent();
    };

    const toHome = () => {
      templateGroupRef.value.toHome();
    };

    const toHistoryOrCollection = value => {
      templateGroupRef.value.onCardClick({
        type: 'history_collection',
        value: value
      });
    };

    const pageParams = inject('pageParams');
    watch(() => props.modelValue, val => {
      if (val) {
        console.log('pageParams', pageParams);
      }
    });
    return (_ctx, _cache) => {
      const _component_m_dialog = _resolveComponent("m-dialog");

      return _openBlock(), _createBlock(_component_m_dialog, {
        autoLoading: "",
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        nativeConfig: {
          width: '73.333vw',
          top: '5vh',
          closeOnClickModal: false
        },
        "dialog-config": actionForm.dialogConfig,
        onOnClose: actionForm.close
      }, {
        default: _withCtx(() => [_unref(pageParams).uiDirection == 0 ? (_openBlock(), _createBlock(DefaultStyle, {
          key: 0
        })) : _createCommentVNode("", true), _unref(pageParams).uiDirection == 1 ? (_openBlock(), _createBlock(ArabicStyle, {
          key: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "nativeConfig", "dialog-config", "onOnClose"]);
    };
  }

});